import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var MessageDtoFailureReasonInline;
(function (MessageDtoFailureReasonInline) {
    MessageDtoFailureReasonInline["PROMPT_TOO_LARGE"] = "PROMPT_TOO_LARGE";
})(MessageDtoFailureReasonInline || (MessageDtoFailureReasonInline = {}));
export var MessageDtoRoleInline;
(function (MessageDtoRoleInline) {
    MessageDtoRoleInline["USER"] = "USER";
    MessageDtoRoleInline["ASSISTANT"] = "ASSISTANT";
})(MessageDtoRoleInline || (MessageDtoRoleInline = {}));
export var MessageDtoStatusInline;
(function (MessageDtoStatusInline) {
    MessageDtoStatusInline["PENDING"] = "PENDING";
    MessageDtoStatusInline["IN_PROGRESS"] = "IN_PROGRESS";
    MessageDtoStatusInline["COMPLETED"] = "COMPLETED";
    MessageDtoStatusInline["FAILED"] = "FAILED";
})(MessageDtoStatusInline || (MessageDtoStatusInline = {}));
export var TaskFormTaskTypeInline;
(function (TaskFormTaskTypeInline) {
    TaskFormTaskTypeInline["IMAGE"] = "IMAGE";
    TaskFormTaskTypeInline["VIDEO"] = "VIDEO";
})(TaskFormTaskTypeInline || (TaskFormTaskTypeInline = {}));
export var TaskGenerationEnum;
(function (TaskGenerationEnum) {
    TaskGenerationEnum["IN_PROGRESS"] = "IN_PROGRESS";
    TaskGenerationEnum["COMPLETED"] = "COMPLETED";
    TaskGenerationEnum["CANCELED"] = "CANCELED";
    TaskGenerationEnum["FAILED"] = "FAILED";
})(TaskGenerationEnum || (TaskGenerationEnum = {}));
/** An agent's classification. REGULAR and PRESENTATION agents appear in the chat selector; REPORTING agents drive the conversational report-spec tools and are fetched only by the reporting context. */
export var AgentCategory;
(function (AgentCategory) {
    AgentCategory["REGULAR"] = "REGULAR";
    AgentCategory["PRESENTATION"] = "PRESENTATION";
    AgentCategory["REPORTING"] = "REPORTING";
})(AgentCategory || (AgentCategory = {}));
/** A getAgents filter that expands to a set of categories: CHAT -> [REGULAR, PRESENTATION], REPORT -> [REPORTING], ALL -> every category. */
export var AgentCategoryBundle;
(function (AgentCategoryBundle) {
    AgentCategoryBundle["ALL"] = "ALL";
    AgentCategoryBundle["CHAT"] = "CHAT";
    AgentCategoryBundle["REPORT"] = "REPORT";
})(AgentCategoryBundle || (AgentCategoryBundle = {}));
/** Discriminator for a message's structured (non-text) output, carried as the type of the structuredOutput envelope. Add a value here for each new output kind. */
export var MessageOutputType;
(function (MessageOutputType) {
    MessageOutputType["REPORT_SPEC"] = "REPORT_SPEC";
})(MessageOutputType || (MessageOutputType = {}));
export var ModelTypeEnum;
(function (ModelTypeEnum) {
    ModelTypeEnum["TEXT"] = "TEXT";
    ModelTypeEnum["IMAGE"] = "IMAGE";
    ModelTypeEnum["VIDEO"] = "VIDEO";
})(ModelTypeEnum || (ModelTypeEnum = {}));
export var TaskTypeEnum;
(function (TaskTypeEnum) {
    TaskTypeEnum["IMAGE"] = "IMAGE";
    TaskTypeEnum["VIDEO"] = "VIDEO";
})(TaskTypeEnum || (TaskTypeEnum = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE"] = "BY_POSITION_END_DATE";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["WEEKLY"] = "WEEKLY";
    ReportingType["BY_END_DATE"] = "BY_END_DATE";
    ReportingType["FLIGHT_EXPIRATION"] = "FLIGHT_EXPIRATION";
    ReportingType["MANUAL"] = "MANUAL";
})(ReportingType || (ReportingType = {}));
export var TargetingMode;
(function (TargetingMode) {
    TargetingMode["EXCLUDE"] = "EXCLUDE";
    TargetingMode["INCLUDE"] = "INCLUDE";
})(TargetingMode || (TargetingMode = {}));
export var CampaignStage;
(function (CampaignStage) {
    CampaignStage["OFFERED"] = "OFFERED";
    CampaignStage["OFFER_DENIED"] = "OFFER_DENIED";
    CampaignStage["ALTERNATE_QUOTE"] = "ALTERNATE_QUOTE";
    CampaignStage["BOOKED"] = "BOOKED";
    CampaignStage["PERFORMANCE"] = "PERFORMANCE";
    CampaignStage["DRAFT"] = "DRAFT";
    CampaignStage["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStage["ARCHIVED"] = "ARCHIVED";
    CampaignStage["PREPAYMENT"] = "PREPAYMENT";
})(CampaignStage || (CampaignStage = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
